<template>
    <div class="content">
        <div class="first">
            <p class="title">初试人</p>
            <div v-for="(v,i) in resultList" :key="i" v-show="v.stage==1">
                <p class="name">{{v.interview_name}}</p>
                <p class="offer">{{v.status | dealStatus}}</p>
                <p class="evaluate">{{v.remark}}</p>
            </div>
            
        </div>
        <div class="complex">
            <p class="title">复试人</p>
            <div v-for="(v,i) in resultList" :key="i" v-show="v.stage==2">
                <p class="name">{{v.interview_name}}</p>
                <p class="offer">{{v.status | dealStatus}}</p>
                <p class="evaluate">{{v.remark}}</p>
            </div>
            
        </div>
        <div class="policy">
            <p class="title">决策人</p>
            <div v-for="(v,i) in jcrList" :key="i" v-show="v.stage==3">
            <p class="name">{{v.interview_name}}</p>
                <p class="offer">{{v.status | dealStatus}}</p>
                <p class="evaluate">{{v.remark}}</p>
            </div>
            <div class="btn_group">
                <p :class="{staRed:index===1,staGrea:index!==1}" @click="checkedStatus(1)"><img :src="require('@/assets/img/laugh.png')"><span>录用</span></p>
                <p :class="{staRed:index===-1,staGrea:index!==-1}" @click="checkedStatus(-1)"><img :src="require('@/assets/img/cry.png')"><span>不录用</span></p>
            </div>
        </div>
        <div class="e_section">
            <van-field v-model="text" type="textarea" label=""  rows="5"/>
        </div>
        <div class="e_btn_box" v-if="!status">
            <van-button class="e_btn" type="danger" @click="subResult">提交</van-button>
        </div>
    </div>
</template>

<script>
import { doAuditionResultApi,getAuditionResultList } from '@/api/interview'
import { Toast } from 'vant';
    export default {
        data(){
            return {
                index:0,
                text:"",
                resultList:[],
                jcrList:[],
                resumeID:0,
                id:0,
                policyName:"",
                status:0,
                isClick:true
            }
        },
        methods:{
            //点击切换状态
            checkedStatus(type){
                this.index = type
            },
            // 提交
            subResult(){
                if(this.index===0){
                    Toast('请选择是否录用');
                    return
                }
                // if(this.text===""){
                //     Toast('请输入评价');
                //     return
                // }
                if(!this.isClick){
                    return
                }
                this.isClick = false
                const params = {
                    interview_id:this.$route.query.id,
                    status:this.index,
                    remark:this.text
                }
                doAuditionResultApi(params).then(res=>{
                    if(res.errNo===0){
                        this.isEvaluate = false
                        this.isBtn = false
                        // Toast('提交成功');
                        this.$router.push('/interviews/submit_success')
                    }else{
                        this.isClick = true
                        Toast(res.msg);
                    }
                })
            },
            getData(){
                // const res = {"errNo":0,"msg":"success","result":[{"stage":1,"interview_name":"王雅琦","status":1,"remark":"好"},{"stage":2,"interview_name":"王雅琦","status":1,"remark":"eeeee"},{"stage":3,"interview_name":"王雅琦","status":1,"remark":"333"},{"stage":3,"interview_name":"王雅琦","status":0,"remark":""}]}
                
                getAuditionResultList({id:this.resumeID}).then(res=>{
                    if(res.errNo===0){
                        this.resultList = res.result.list
                        this.resultList.forEach(ele => {
                            if(ele.stage == 3){
                                this.jcrList.push(ele)
                            }
                        });
                        this.id = res.result.id
                        this.policyName = res.result.interview_name
                        if( res.result.status != undefined && res.result.status!=0 ){
                            console.log(123)
                            this.index = res.result.status===1 ? 1 : -1 
                            this.status = res.result.status
                        }
                    } else {
                        Toast(res.msg);
                    }
                })
            },
        },
        filters:{
            dealStatus(val){
                if(val==0){
                    return '未处理'
                }
                if(val==-1){
                    return '不录用'
                }
                if(val==1){
                    return '录用'
                }
                if(val==2){
                    return '力荐'
                }
                if(val==3){
                    return '已转出'
                }
            }
        },
        created(){
            this.resumeID = this.$route.query.id
            this.getData()
        }
    }
</script>

<style scoped lang="less">
.content{
    padding: 40px 20px 40px;
}
.title {
    border-left: 6px solid red;
    font-size: 36px;
    letter-spacing: 2px;
    padding-left: 10px;
    height: 30px;
    line-height: 34px;
}
.name {
    padding: 20px 16px;
    font-size: 26px;
    color: #333;
}
.offer {
    padding: 20px 16px;
    font-size: 26px;
    color: #ee0a24;
}
.evaluate {
    padding-left: 16px;
    font-size: 26px;
    color: #333;
}
.complex {
    padding: 60px 0;
}
.btn_group{
    display: flex;
    padding-left: 16px;
    margin-top: 40px;
    p{
        text-align: center;
        line-height: 70px;
        position: relative;
        margin-right: 20px;
        img {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 14px;
        }
        span {
            padding-left: 46px;
        }
    }
}
.staRed{
    width: 30%;
    height: 70px;
    background: #ee2e2e;
    color: #fff;
}
.staGrea{
    width: 30%;
    height: 70px;
    background: #eeeeee;
}
.e_section {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
}
/deep/ .van-cell {
    background-color: #fafafa;
    width: 96%;
}
.e_btn_box {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    .e_btn {
        width: 96%;
        border-radius: 8px;
    }
}
</style>